var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header-buttons--group"},[(_vm.backUrl != null)?_c('a',{staticClass:"form-header-buttons--back btn btn-light-grey",attrs:{"href":_vm.backUrl}},[_vm._v("Back")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"form-header-buttons--save btn btn-primary",attrs:{"href":"#"},on:{"click":_vm.save}},[_vm._v("Save")])])
}
var staticRenderFns = []

export { render, staticRenderFns }